import { useEffect } from 'react'
import { env } from '@/env'
import { useBreadcrumbs } from './use-breadcrumbs'

export function TitleFromBreadcrumbs() {
	const crumbs = useBreadcrumbs()

	useEffect(() => {
		const labels = crumbs.map((c) => c.crumb.label)
		if (labels.length)
			document.title = `${env.VITE_APP_TITLE}: ${labels.toReversed().join(' – ')}`
	}, [crumbs])

	return null
}
